export default "__VITE_ASSET__BWYmc_Ng__"